import React, { useEffect, useState } from "react";
import { List, ListItemIcon, ListItemText, Divider } from "@material-ui/core";
import DashboardRoundedIcon from "@material-ui/icons/DashboardRounded";
import DevicesRoundedIcon from "@material-ui/icons/DevicesRounded";
import AlarmRoundedIcon from "@material-ui/icons/AlarmRounded";
import StorageRoundedIcon from "@material-ui/icons/StorageRounded";
import LockRoundedIcon from "@material-ui/icons/LockRounded";
import AnnouncementOutlined from "@material-ui/icons/AnnouncementOutlined";
import DrawerListItems from "./DrawerListItems";
import PowerManagementIcon from "@material-ui/icons/PowerSettingsNew";
import SettingsRemoteIcon from "@material-ui/icons/SettingsRemote";
import useStyles from "../../styles/drawerStyle";
import ListItemLink from "../commons/ListItemLink";
import { useTranslation } from "../../langs/useTranslation";
import HasPermission from "../commons/HasPermission";
import {
  /*drawerNubisDocListItems,*/ drawerNubisDriveListItems,
  drawerGroupsListItems,
  getDrawerAlarmListItems
} from "../../config/drawerListItems";
import Cookies from "js-cookie";
import ListItemCollapser from "../ListItemCollapser";
import { AccessAlarm, CalendarToday, Devices, Group } from "@material-ui/icons";
import { useLocation } from "react-router-dom";
import { getPermissions } from "@/apis/getPermisions";
import {
  IconConfig,
  IconContentManagement,
  IconProfileConfig,
  IconSetting,
  IconSettingProfile
} from "../Icon";
import { IconNavAnnouncement } from "@/components/Icon";
import Announcement from "@/containers/Announcement";
import { APP_ENV } from "@/APP_ENV";
// import WidgetsIcon from "@material-ui/icons/Widgets";

const removeCookies = () => {
  Cookies.remove("select_type");
  Cookies.remove("select_tag");
  Cookies.remove("select_company");
  Cookies.remove("select_group");
};

const DrawerList = props => {
  const { t, langConf } = useTranslation("common");
  const classes = useStyles();
  const location = useLocation();

  const { isListExpanded } = props;
  const [isShowExpandedList, setIsShowExpandedList] = useState(isListExpanded);
  // const [isShowNubisDocList, setIsShowNubisDocList ] = useState(false);
  const [isShowNubisDriveList, setIsShowNubisDriveList] = useState(true);
  // let nubisDocListPermissions = drawerNubisDocListItems.map( o => o.permission);
  let NubisDriveListPermissions = drawerNubisDriveListItems.map(
    o => o.permission
  );

  const checkIsShowNubisDocList = () => {
    // const userPermissions = getPermissions();
    // if (userPermissions) {
    //   const hasNubisDrivePermission = userPermissions.filter(element =>
    //     NubisDriveListPermissions.includes(element)
    //   );
    //   // setIsShowNubisDocList(hasNubisDocPermission.length>0)
    //   setIsShowNubisDriveList(hasNubisDrivePermission.length > 0);
    // }
  };

  useEffect(() => {
    setIsShowExpandedList(isListExpanded);
    checkIsShowNubisDocList();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isListExpanded]);

  const drawerAlarmListItems = [
    {
      permission: "Alarm Management",
      link: "/alarm/templates",
      text: t({ defaultMessage: "模板列表" }),
      disabled: false
    },
    {
      permission: "Alarm Management",
      link: "/alarm/device-list",
      text: t({ defaultMessage: "设备列表" }),
      disabled: false
    },
    {
      permission: "Alarm Management",
      link: "/alarm/history",
      text: t({ defaultMessage: "历史记录" }),
      disabled: false
    }
  ];

  const drawerScheduleListItems = [
    {
      permission: "Schedule Task Management",
      link: "/schedule/templates",
      text: t({ defaultMessage: "排程模板列表" }),
      disabled: false
    },
    {
      permission: "Schedule Task Management",
      link: "/schedule/list",
      text: t({ defaultMessage: "设备排程列表" }),
      disabled: false
    },
    {
      permission: "Schedule Task Management",
      link: "/schedule/history",
      text: t({ defaultMessage: "排程执行历史记录" }),
      disabled: false
    },
    {
      permission: "Schedule Task Management",
      link: "/schedule/calendar",
      text: t({ defaultMessage: "设备排程日历" }),
      disabled: false
    }
  ];

  const drawerCMSListItems = [
    {
      permission: "Content Template List",
      link: "/cms/template/list",
      text: t({ defaultMessage: "内容模板列表" }),
      disabled: false
    },
    {
      permission: "Resource Library",
      link: "/cms/resource/list",
      text: t({ defaultMessage: "资源管理中心" }),
      disabled: false
    },
    {
      permission: "Content History",
      link: "/cms/history",
      text: t({ defaultMessage: "内容历史记录" }),
      disabled: false
    }
  ];

  const profileConfigListItems = [
    {
      permission: "profile_template_view",
      link: "/profile-config/template",
      text: t({ defaultMessage: "配置模板" }),
      disabled: false
    },
    {
      permission: "profile_install_history_view",
      link: "/profile-config/install-history",
      text: t({ defaultMessage: "安装历史" }),
      disabled: false
    }
  ];

  const settingConfigListItems = [
    {
      permission: ["company_setting_view", "device_naming_method_view"],
      link: "/setting/company",
      text: t({ defaultMessage: "公司设置" }),
      disabled: false
    },
    {
      permission: "device_naming_method_view",
      link: "/setting/device-naming/list",
      text: t({ defaultMessage: "设备命名规则" }),
      disabled: false
    }
  ];

  return (
    <>
      <List className={classes.listWrappper}>
        <HasPermission permission="DashBoard">
          <ListItemLink to="/dashboard">
            <ListItemIcon>
              <DashboardRoundedIcon />
            </ListItemIcon>
            <ListItemText>{t("drawer.dashboard")}</ListItemText>
          </ListItemLink>
          <Divider />
        </HasPermission>
        {/* <HasPermission permission="Device Monitoring">
          <ListItemLink
            to="/groups"
            disabled
            className={classes.drawerListCategoryTitle}
          >
            <ListItemIcon>
              <GroupIcon />
            </ListItemIcon>
            <ListItemText>{t("drawer.groups-devices")}</ListItemText>
          </ListItemLink>
          {isShowExpandedList && (
            <DrawerListItems listItems={drawerGroupsListItems} />
          )}
          <Divider />
        </HasPermission> */}
        <HasPermission permission="Device Monitoring">
          <ListItemCollapser
            defaultOpen={location.pathname.startsWith("/groups/")}
            icon={<Devices />}
            title={t("drawer.deviceMonitoring")}
            className={classes.drawerListCategoryTitle}
          >
            {isShowExpandedList && (
              <DrawerListItems listItems={drawerGroupsListItems} />
            )}
          </ListItemCollapser>
          <Divider />
        </HasPermission>

        <HasPermission permission="Profile Management">
          <ListItemCollapser
            defaultOpen={location.pathname.startsWith("/profile/")}
            icon={<IconProfileConfig size={18} color="#000" />}
            title={t({ defaultMessage: "配置文件管理" })}
            className={classes.drawerListCategoryTitle}
          >
            {isShowExpandedList && (
              <DrawerListItems translated listItems={profileConfigListItems} />
            )}
          </ListItemCollapser>
          <Divider />
        </HasPermission>
        {/* <HasPermission permission="Device Monitoring">
          <ListItemLink to="/device-list" onClick={removeCookies}>
            <ListItemIcon>
              <DevicesRoundedIcon />
            </ListItemIcon>
            <ListItemText>{t("drawer.deviceMonitoring")}</ListItemText>
          </ListItemLink>
          <Divider />
        </HasPermission> */}
        {/* <HasPermission permission="multiple_page"> */}
        <HasPermission permission="Alarm Management">
          <ListItemCollapser
            defaultOpen={location.pathname.startsWith("/alarm/")}
            icon={<AccessAlarm />}
            title={t({ defaultMessage: "报警管理" })}
            className={classes.drawerListCategoryTitle}
          >
            {isShowExpandedList && (
              <DrawerListItems translated listItems={drawerAlarmListItems} />
            )}
          </ListItemCollapser>
          <Divider />
        </HasPermission>
        <HasPermission permission="Schedule Task Management">
          <ListItemCollapser
            defaultOpen={location.pathname.startsWith("/schedule/")}
            icon={<CalendarToday />}
            title={t({ defaultMessage: "排程管理" })}
            className={classes.drawerListCategoryTitle}
          >
            {isShowExpandedList && (
              <DrawerListItems translated listItems={drawerScheduleListItems} />
            )}
          </ListItemCollapser>
          <Divider />
        </HasPermission>
        {/* <HasPermission permission=""> */}
        {APP_ENV.REACT_APP_CMS_ENABLED && (
          <HasPermission permission="Content Management">
            <ListItemCollapser
              defaultOpen={location.pathname.startsWith("/cms/")}
              icon={<IconContentManagement size={18} />}
              title={t({ defaultMessage: "内容管理" })}
              className={classes.drawerListCategoryTitle}
            >
              {isShowExpandedList && (
                <DrawerListItems translated listItems={drawerCMSListItems} />
              )}
            </ListItemCollapser>
            <Divider />
          </HasPermission>
        )}
        {/* </HasPermission> */}
        {/* <ListItemLink to="/device-control">
          <ListItemIcon>
            <SettingsRemoteIcon />
          </ListItemIcon>
          <ListItemText>{t("drawer.deviceControl")}</ListItemText>
        </ListItemLink> */}
        {/* </HasPermission> */}
        {/* <HasPermission permission="power_management_page"> */}

        {/* <ListItemLink to="/power-management">
          <ListItemIcon>
            <PowerManagementIcon />
          </ListItemIcon>
          <ListItemText>{t("drawer.powerManagement")}</ListItemText>
        </ListItemLink>
        <Divider /> */}

        {/* </HasPermission>
        <HasPermission permission="alarm_notification_page"> */}
        {/* <ListItemLink to="/alarm-notification">
          <ListItemIcon>
            <AlarmRoundedIcon />
          </ListItemIcon>
          <ListItemText>{t("drawer.alarmNotification")}</ListItemText>
        </ListItemLink> */}
        {/* <Divider /> */}
        {/* </HasPermission> */}
        {/* { isShowNubisDocList &&
                    <>
                        <ListItemLink to="/nubis-docs" disabled>
                            <ListItemIcon><InsertDriveFileRoundedIcon /></ListItemIcon>
                            <ListItemText>{t('drawer.nubisDocs')}</ListItemText>
                        </ListItemLink>
                        {isShowExpandedList && (<DrawerListItems listItems={drawerNubisDocListItems} />)}
                        <Divider />
                    </>
                }  */}
        {isShowNubisDriveList && (
          <HasPermission
            permissions={[
              "Nubis Drive",
              "android_app_management_view",
              "file_management_view",
              "file_brower_view",
              "share_with_me_view"
            ]}
          >
            <ListItemCollapser
              defaultOpen={location.pathname.startsWith("/nubis-drive/")}
              icon={<StorageRoundedIcon />}
              title={langConf.nubisDrive?.text || t("drawer.nubisDrive")}
              className={classes.drawerListCategoryTitle}
            >
              {isShowExpandedList && (
                <DrawerListItems listItems={drawerNubisDriveListItems} />
              )}
            </ListItemCollapser>
            <Divider />
          </HasPermission>
        )}
        {/* <HasPermission permission="permissions_page"> */}
        {/* <ListItemLink to="/permission" disabled>
          <ListItemIcon>
            <LockRoundedIcon />
          </ListItemIcon>
          <ListItemText>{t("drawer.permission")}</ListItemText>
        </ListItemLink>
        <Divider /> */}
        {/* </HasPermission> */}
        {/* <HasPermission permission="app_update_service_page">
          <ListItemLink to="/app-update-service">
            <ListItemIcon>
              <WidgetsIcon />
            </ListItemIcon>
            <ListItemText>{t("drawer.appUpdateService")}</ListItemText>
          </ListItemLink>
          <Divider />
        </HasPermission> */}
        <HasPermission
          permission={["Company Setting", "device_naming_method_view"]}
        >
          <ListItemCollapser
            defaultOpen={location.pathname.startsWith("/setting/")}
            icon={<IconSettingProfile size={18} color="#000" />}
            title={t({ defaultMessage: "设置" })}
            className={classes.drawerListCategoryTitle}
          >
            {isShowExpandedList && (
              <DrawerListItems translated listItems={settingConfigListItems} />
            )}
          </ListItemCollapser>
          <Divider />
        </HasPermission>

        <ListItemLink to="/announcement">
          <ListItemIcon>
            {/*<AnnouncementOutlined />*/}
            <IconNavAnnouncement style={{ fontSize: 18, color: "#000" }} />
          </ListItemIcon>
          <ListItemText>{t({ defaultMessage: "通知中心" })}</ListItemText>
        </ListItemLink>
        <Divider />
      </List>
    </>
  );
};

export default DrawerList;
